import { render, staticRenderFns } from "./topic-list.vue?vue&type=template&id=b8c7cfb2&scoped=true&"
import script from "./topic-list.vue?vue&type=script&lang=js&"
export * from "./topic-list.vue?vue&type=script&lang=js&"
import style0 from "./topic-list.vue?vue&type=style&index=0&id=b8c7cfb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c7cfb2",
  null
  
)

export default component.exports